module.exports = __webpack_public_path__ + "static/img/2a.c3236a78.png";